module.exports = __webpack_public_path__ + "static/emotion-ef0d21fc6655bdd0d54f0bffe7f86dc5.png";